import comp from "./TruncateWithTooltip";
export default comp;
